import {
  apiParam,
  craftResearchQuestionProcessed,
  formatResponse,
  generateSearchQueryOrdered,
  sanitiseResearchQuestion
} from './aiHelper'
import {getRelevantKeywords, getResearchQuestionPhraseExtraction} from '../src/utils/nlp-api-v2'

export const searchAiState = {
  state: () => ({
    showStates: {
      researchQuestionInput: { showSection: true, triggerAnimation: true },
      researchQuestionDisplay: { showSection: false, triggerAnimation: true },
      keyConceptsSection: { showSection: false, showHintBar: true, triggerAnimation: true },
      keywordsSection: { showSection: false, showHintBar: true, isLoading: true, triggerAnimation: true }
    },
    aiState: 0,
    researchQuestion: '',
    researchQuestionInput: '',
    keepRQInput: false,
    researchQuestionProcessed: [],
    // { phrase: ['What', 'is'], isFacet: true, isShowing: true (for animation)}
    showErrorMessageRQInput: false,
    relevantKeywordsOrdered: [
      // {
      //   'effects': {
      //      selectedState: 'partial' | 'selected' | 'unselected',
      //      terms: {'adverse': {isSelected: false, isShowing: false}, {'cause': {isSelected: false, isShowing: false}}, {'caused': {isSelected: false, isShowing: false}}, {'effect': {isSelected: false, isShowing: false}}}
      //   }
      // }
    ],
    contentGenerated: false,
    footerPrimaryBtnText: 'Next',
    finalSearchQuery: null,
    animationSpeed: 250
  }),
  getters: {
    getResearchQuestionInputState (state) {
      return state.showStates.researchQuestionInput
    },
    getResearchQuestionDisplayState (state) {
      return state.showStates.researchQuestionDisplay
    },
    getKeyConceptsSectionState (state) {
      return state.showStates.keyConceptsSection
    },
    getKeywordsSectionState (state) {
      return state.showStates.keywordsSection
    },
    getResearchQuestion (state) {
      return state.researchQuestionInput
    },
    researchQuestionLength (state) {
      return state.researchQuestion.length
    },
    getSelectedFacets (state) {
      return state.researchQuestionProcessed.filter(function (obj) { return obj.isFacet === true })
    },
    getSelectedFacetsLength (state, getters) {
      return getters.getSelectedFacets.length
    },
    getShowErrorMessageRQInput (state) {
      return state.showErrorMessageRQInput
    },
    getResearchQuestionProcessed (state) {
      return state.researchQuestionProcessed
    },
    getRelevantKeywordsOrdered (state) {
      return state.relevantKeywordsOrdered
    },
    getContentGenerated (state) {
      return state.contentGenerated
    },
    getFooterPrimaryBtnText (state) {
      return state.footerPrimaryBtnText
    },
    getFinalSearchQuery (state) {
      return state.finalSearchQuery
    },
    disableInputBtn (state) {
      return !state.researchQuestionInput.length > 0
    },
    getAnimationSpeed (state) {
      return state.animationSpeed
    }
  },
  mutations: {
    setKeyConceptSectionAnimation: (state, value) => {
      state.showStates.keyConceptsSection.triggerAnimation = value
    },
    setIsLoadingKeywordsSection: (state, value) => {
      state.showStates.keywordsSection.isLoading = value
    },
    setResearchQuestion: (state, researchQuestion) => {
      state.researchQuestion = researchQuestion
    },
    setResearchQuestionInput: (state, researchQuestion) => {
      state.researchQuestionInput = researchQuestion
    },
    setResearchQuestionProcessed: (state, researchQuestionProcessed) => {
      state.researchQuestionProcessed = researchQuestionProcessed
    },
    setShowErrorMessageRQInput: (state, showErrorMessageRQInput) => {
      state.showErrorMessageRQInput = showErrorMessageRQInput
    },
    setContentGenerated: (state, newValue) => {
      state.contentGenerated = newValue
    },
    toggleRelevantKeywordsOrderedTermState: (state, {groupName, term}) => {
      const elIndex = state.relevantKeywordsOrdered
        .findIndex(el => Object.keys(el)[0] === groupName && el[groupName].terms.hasOwnProperty(term))
      if (elIndex >= 0) {
        state.relevantKeywordsOrdered[elIndex][groupName].terms[term].isSelected = !state.relevantKeywordsOrdered[elIndex][groupName].terms[term].isSelected
      }
    },
    updateRelevantKeywordsGroupState: (state, groupName) => {
      const elIndex = state.relevantKeywordsOrdered.findIndex(el => Object.keys(el)[0] === groupName)
      if (elIndex >= 0) {
        const isSettingToTrue = state.relevantKeywordsOrdered[elIndex][groupName].selectedState !== 'checked'
        const tempTerms = state.relevantKeywordsOrdered[elIndex][groupName].terms
        for (const el in tempTerms) {
          tempTerms[el].isSelected = isSettingToTrue
        }
        state.relevantKeywordsOrdered[elIndex][groupName].terms = tempTerms
        state.relevantKeywordsOrdered[elIndex][groupName].selectedState = isSettingToTrue ? 'checked' : 'unchecked'
      }
    },
    updateAiSectionState: (state) => {
      switch (state.aiState) {
        case 0: // User Input RQ
          state.showStates.researchQuestionInput.showSection = true
          state.showStates.researchQuestionDisplay.showSection = false
          state.showStates.keyConceptsSection.showSection = false
          state.showStates.keywordsSection.showSection = false
          state.researchQuestion = ''
          if (!state.keepRQInput) state.researchQuestionInput = ''
          state.researchQuestionProcessed = []
          state.relevantKeywordsOrdered = []
          state.finalSearchQuery = null
          state.contentGenerated = false
          state.footerPrimaryBtnText = 'Next'
          break
        case 1: // User Selects Facets
          state.showStates.researchQuestionInput.showSection = false
          state.showStates.researchQuestionDisplay.showSection = true
          state.showStates.keyConceptsSection.showSection = true
          state.showStates.keyConceptsSection.showHintBar = true
          state.showStates.keywordsSection.showSection = false
          state.relevantKeywordsOrdered = []
          state.contentGenerated = false
          state.footerPrimaryBtnText = 'Next'
          break
        case 2: // User Selects keywords
          state.showStates.researchQuestionInput.showSection = false
          state.showStates.researchQuestionDisplay.showSection = true
          state.showStates.keyConceptsSection.showSection = true
          state.showStates.keyConceptsSection.showHintBar = false
          state.showStates.keywordsSection.showSection = true
          state.showStates.keywordsSection.showHintBar = true
          state.contentGenerated = false
          state.footerPrimaryBtnText = 'Generate'
          break
        case 3: // Content Generated to canvas
          state.showStates.researchQuestionInput.showSection = false
          state.showStates.researchQuestionDisplay.showSection = true
          state.showStates.researchQuestionDisplay.showEditBtn = true
          state.showStates.keyConceptsSection.showSection = true
          state.showStates.keyConceptsSection.showHintBar = false
          state.showStates.keywordsSection.showSection = true
          state.showStates.keywordsSection.showHintBar = false
      }
    }
  },
  actions: {
    processResearchQuestion ({commit, getters, state, dispatch}) {
      commit('setResearchQuestion', sanitiseResearchQuestion(state.researchQuestionInput))
      if (getters.researchQuestionLength > 0) {
        getResearchQuestionPhraseExtraction(state.researchQuestion, apiParam)
          .then(response => {
            const responseArray = getSortedResponseArray(response)
            commit('setResearchQuestionProcessed', craftResearchQuestionProcessed(responseArray, state.researchQuestion))
          })
          .then(_ => {
            if (getters.getSelectedFacetsLength === 0) {
              commit('setShowErrorMessageRQInput', true)
            } else {
              commit('setShowErrorMessageRQInput', false)
              dispatch('updateAiState', 1)
            }
          })
      }
      const getSortedResponseArray = (response) => {
        return response.response.sort(comparePositionInRQ)
      }
      const comparePositionInRQ = (a, b) => {
        if (state.researchQuestion.search(a) < state.researchQuestion.search(b)) {
          return -1
        } else if (state.researchQuestion.search(a) > state.researchQuestion.search(b)) {
          return 1
        }
        return 0
      }
    },
    handleWordClick ({state}, word) {
      if (word.length > 0) {
        state.researchQuestionProcessed.forEach(wordGroup => {
          if (wordGroup.phrase[0] === word[0]) {
            wordGroup.isFacet = !wordGroup.isFacet
          }
        })
      }
    },
    handleGroupTerms ({state, commit}, word) {
      let index = 0
      while (index < state.researchQuestionProcessed.length) {
        if (state.researchQuestionProcessed[index].phrase[0] === word[0]) {
          let localTerms = state.researchQuestionProcessed
          localTerms[index].phrase.push(...localTerms[index + 1].phrase)
          localTerms.splice(index + 1, 1)
          localTerms[index].isFacet = true
          commit('setResearchQuestionProcessed', localTerms)
          index = state.researchQuestionProcessed.length
        }
        index++
      }
    },
    handleSplitTerms ({state}, {splitIndex, word}) {
      let index = 0
      while (index < state.researchQuestionProcessed.length) {
        if (state.researchQuestionProcessed[index].phrase[0] === word[0]) {
          let firstPartOfPhrase = state.researchQuestionProcessed[index].phrase.slice(0, splitIndex)
          let secondPartOfPhrase = state.researchQuestionProcessed[index].phrase.slice(splitIndex)
          state.researchQuestionProcessed[index].phrase = firstPartOfPhrase

          state.researchQuestionProcessed.splice(index + 1, 0, {
            phrase: secondPartOfPhrase,
            isFacet: state.researchQuestionProcessed[index].isFacet,
            isShowing: true
          })
          index = state.researchQuestionProcessed.length
        }
        index++
      }
    },
    handleNextKeywordsSection ({state, getters, commit, dispatch}) {
      commit('setIsLoadingKeywordsSection', true)
      dispatch('updateAiState', 2)
      if (getters.getSelectedFacetsLength > 0) {
        const makeRequest = (facetArray) => {
          if (facetArray.length > 0) {
            setTimeout(() => {
              getRelevantKeywords(facetArray[0].phrase.join(' '), state.researchQuestion)
                .then(response => {
                  if (response.response === -1) {
                    // @todo - implement rateLimit
                    this.rateLimitHit = true
                  } else {
                    // @todo - implement rateLimit
                    this.rateLimitHit = false
                    // eslint-disable-next-line
                    let processedResponse = formatResponse(response.response, facetArray[0])
                    state.relevantKeywordsOrdered.push({[facetArray[0].phrase.join(' ')]: { 'terms': processedResponse, 'selectedState': 'partial' }})
                    if (getters.getSelectedFacetsLength === state.relevantKeywordsOrdered.length) {
                      state.showStates.keywordsSection.isLoading = false
                    }
                  }
                })
            }, 100)
            setTimeout(() => makeRequest(facetArray.slice(1)), 100)
          } else {
          }
        }
        makeRequest(getters.getSelectedFacets)
      }
    },
    handleGenerateContent ({state, getters, commit, dispatch}) {
      state.finalSearchQuery = generateSearchQueryOrdered(getters.getRelevantKeywordsOrdered)
      dispatch('updateAiState', 3)
      commit('setContentGenerated', true)
    },
    updateAiState ({state, commit}, newState) {
      if (newState >= 0 && newState <= 3) {
        state.aiState = newState
        state.keepRQInput = true
        commit('updateAiSectionState')
      }
    },
    aiStateReverse ({state, commit}) {
      if (state.aiState > 0) {
        state.aiState = state.aiState - 1
        commit('updateAiSectionState')
      }
    },
    resetAiState ({state, commit}) {
      state.aiState = 0
      state.keepRQInput = false
      commit('updateAiSectionState')
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/searchAiState.js
// module id = null
// module chunks = 